export default __webpack_public_path__ + "static/media/receipt.d71acdc2.png";